const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* ------------------------------------------------------------------
   pk-ship-sync
   Lista "darmowa dostawa" v sekci pk-pdp ukazuje VYHRADNE stav kosiku.
   Nikdy nezapocitava prave vybrane baleni - jinak by tvrdila
   "Darmowa dostawa wlaczona" i ve chvili, kdy v kosiku prah splneny neni
   a zakaznik by u pokladny dopravu zaplatil.

   Sedi v constants.js, protoze se nacita na kazde strance a nebylo
   nutne kvuli jednomu radku prepisovat cely layout/theme.liquid.
   Mimo stranky s [data-shipbox] se sam vypne.

   Zavisi na markupu v sections/pk-pdp.liquid:
     [data-shipbox]   obal listy
     [data-shiptext]  textovy span uvnitr
     .pk-ship__fill   vypln progress baru

   Sekce ma vlastni obsluhu, ktera pri prepnuti baleni zapisuje do listy
   cenu vybraneho baleni. MutationObserver nize kazdy takovy zapis
   okamzite prebije - synchronne z pameti, takze to neproblikava.

   Prah dopravy zdarma: PK_SHIP_THRESHOLD (v groszich, 25000 = 250 zl).
   Prebije ho data-threshold na [data-shipbox], pokud tam bude.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  var PK_SHIP_THRESHOLD = 120000;
  /* Cena dopravy pod hranici (halere). Stejne cislo je v pk-kosik-doprava
     (CENA_DOPRAVY) a v textu ship_left v product.lp.json a page.remarketing.json. */
  var PK_SHIP_PRICE = 9900;
  var cartTotal = 0;
  var lastHTML = null;

  function box() {
    return document.querySelector('[data-shipbox]');
  }

  function threshold() {
    var el = box();
    return (el && parseInt(el.getAttribute('data-threshold'), 10)) || PK_SHIP_THRESHOLD;
  }

    function money(h) {
    var v = h / 100;
    var s = (v % 1 === 0 ? String(v) : v.toFixed(2).replace('.', ','));
    s = s.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return s + ' Kč';
  }

  /* Synchronni vykresleni z pameti - zadny sitovy dotaz, zadne blikani. */
  function paint() {
    var el = box();
    if (!el) return;

    var lim = threshold();
    var left = lim - cartTotal;
    var txt = el.querySelector('[data-shiptext]');
    var fill = el.querySelector('.pk-ship__fill');
    var html;

    /* Člen Probio Klubu s nárokem na dopravu zdarma (od 28. 9. 2026 jen
       s úrovní, nový člen jednou). Značku data-klub-clen dává liště pk-pdp. */
    if (el.hasAttribute('data-klub-clen')) {
      /* Od 28. 9. 2026: „prvni" = nový člen bez úrovně, doprava zdarma
         jen na první objednávku (kód KLUB-PRVNI). */
      html = el.getAttribute('data-klub-clen') === 'prvni'
        ? 'Doprava <b>zdarma</b> · první objednávka v Probio Klubu'
        : 'Doprava <b>zdarma</b> · jste člen Probio Klubu';
      el.setAttribute('data-ship-state', 'ok');
    } else if (left <= 0) {
      html = 'Doprava zdarma aktivována · celkem <b>' + money(cartTotal) + '</b>';
      el.setAttribute('data-ship-state', 'ok');
    } else if (cartTotal > 0) {
      html = 'Doprava <b>' + money(PK_SHIP_PRICE) + '</b> · přidejte ještě <b>' + money(left) + '</b> a máte ji zdarma';
      el.setAttribute('data-ship-state', 'todo');
    } else {
      html = 'Doprava <b>' + money(PK_SHIP_PRICE) + '</b>, od <b>' + money(lim) + '</b> zdarma';
      el.setAttribute('data-ship-state', 'empty');
    }

    if (txt) {
      lastHTML = html;
      if (txt.innerHTML !== html) txt.innerHTML = html;
    }
    if (fill) {
      fill.style.width = (el.hasAttribute('data-klub-clen') ? 100 : Math.min(100, Math.round((cartTotal / lim) * 100))) + '%';
    }

    watch();
  }

  var timer;
  function refresh() {
    if (!box()) return;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          cartTotal = (cart && cart.total_price) || 0;
          paint();
        })
        .catch(function () {});
    }, 120);
  }

  /* Prebije cizi zapis do listy. Smycka nehrozi - vlastni zapis se rovna
     lastHTML a observer ho ignoruje. */
  var observer = null;
  function watch() {
    var el = box();
    if (!el) return;
    var txt = el.querySelector('[data-shiptext]');
    if (!txt || txt.__pkWatched) return;
    txt.__pkWatched = true;
    if (!observer) {
      observer = new MutationObserver(function () {
        var t = box() && box().querySelector('[data-shiptext]');
        if (t && lastHTML !== null && t.innerHTML !== lastHTML) paint();
      });
    }
    observer.observe(txt, { childList: true, characterData: true, subtree: true });
  }

  /* Zapisy do kosiku. /cart.js schvalne NE, jinak by se refresh volal donekonecna. */
  function isCartWrite(url) {
    if (typeof url !== 'string') return false;
    return /\/cart(\/|$)/.test(url.split('?')[0]);
  }

  var origFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0] && (arguments[0].url || arguments[0]);
    var p = origFetch.apply(this, arguments);
    if (isCartWrite(url) && p && p.then) p.then(refresh, refresh);
    return p;
  };

  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartWrite(url)) this.addEventListener('loadend', refresh);
    return origOpen.apply(this, arguments);
  };

  [
    'rebuy:cart.change',
    'rebuy:cart.ready',
    'cart:updated',
    'cart:change',
    'cart:refresh',
    'on:cart:update'
  ].forEach(function (evt) {
    document.addEventListener(evt, refresh);
  });

  /* Prepnuti baleni kosikem nehne - jen prekreslime, aby zapis sekce
     nezustal viset. Kreslime z pameti, takze to neproblikava. */
  function repaintSoon() {
    paint();
    requestAnimationFrame(paint);
    setTimeout(paint, 60);
    setTimeout(paint, 200);
  }
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('button.pk-pack')) repaintSoon();
  }, true);
  ['on:variant:change', 'variant:change', 'shopify:section:load'].forEach(function (evt) {
    document.addEventListener(evt, repaintSoon);
  });

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) refresh();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
